export type KeyDeduper = (name: string) => string;

/**
 * Produces React keys that stay unique when the same wrapper/placeholder name
 * appears more than once in a single interpolation pass (e.g.
 * `[bold]A[/] and [bold]B[/]` or `{user} liked {user}'s post`). The first
 * occurrence of a name keeps the bare name; each subsequent occurrence gets an
 * incrementing suffix (`name`, `name-1`, `name-2`, …) so repeated names can't
 * collide into duplicate keys and cause React to mis-reconcile elements.
 */
export const createKeyDeduper = (): KeyDeduper => {
  const occurrences = new Map<string, number>();

  return (name) => {
    const count = occurrences.get(name) ?? 0;
    occurrences.set(name, count + 1);

    return count === 0 ? name : `${name}-${count}`;
  };
};
